/* eslint-disable import/first */
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import css from './index.module.scss';
import cx from 'classnames';
export default function CustomizationSkelton() {
  return (
    <>
      {/* //{' '} */}
      <div className={css.skeltonVal}>
        <Skeleton
          count={1}
          className={cx(css.SkeletonLoad, css.width300)}
          // width={300}
          height={30}
        />
        <Skeleton count={1} className={css.SkeletonLoad} width={140} height={30} />
        {/* //{' '} */}

        <div className={css.box}>
          <div className={css.thumb}>
            <Skeleton count={1} className={css.SkeletonLoad} width={100} height={80} />
          </div>
          <div className={css.detail}>
            <Skeleton count={1} className={cx(css.SkeletonLoad, css.width300)} height={30} />
            <Skeleton count={1} className={css.SkeletonLoad} width={140} height={30} />
          </div>
        </div>
        <Skeleton count={1} className={css.SkeletonLoad} width={140} height={30} />
        <div className={css.box}>
          <div className={css.thumb}>
            <Skeleton count={1} className={css.SkeletonLoad} width={100} height={80} />
          </div>
          <div className={css.detail}>
            <Skeleton count={1} className={cx(css.SkeletonLoad, css.width300)} height={30} />
            <Skeleton count={1} className={css.SkeletonLoad} width={140} height={30} />
          </div>
        </div>
        <Skeleton count={1} className={css.SkeletonLoad} width={140} height={30} />

        <div className={css.box}>
          <div className={css.thumb}>
            <Skeleton count={1} className={css.SkeletonLoad} width={100} height={80} />
          </div>
          <div className={css.detail}>
            <Skeleton count={1} className={cx(css.SkeletonLoad, css.width300)} height={30} />
            <Skeleton count={1} className={css.SkeletonLoad} width={140} height={30} />
          </div>
        </div>
      </div>

      <div className={css.addButton}>
        <div className={css.box}>
          <div className={css.thumb}>
            <Skeleton count={1} className={css.SkeletonLoad} width={40} height={50} />
          </div>
          <div className={css.detail}>
            <Skeleton count={1} className={cx(css.SkeletonLoad, css.width300)} height={20} />
            <Skeleton count={1} className={css.SkeletonLoad} width={140} height={20} />
          </div>
          <div className={css.thumb}>
            <Skeleton count={1} className={css.SkeletonLoad} width={50} height={50} />
          </div>
        </div>
      </div>
    </>
  );
}
